import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NgbNavModule } from '@ng-bootstrap/ng-bootstrap';

import { FootComponent } from '../../components/foot/foot.component';
import { HeadComponent } from '../../components/head/head.component';

@Component({
  selector: 'app-d120',
    standalone: true,
    imports: [
      CommonModule,
      NgbNavModule,
      HeadComponent,
      FootComponent
    ],
  templateUrl: './d120.component.html',
  styleUrls: ['./d120.component.scss']
})
export class D120Component implements OnInit {

  active = 1;
  
  constructor() { }

  ngOnInit(): void {
  }

}
